import { render, staticRenderFns } from "./address.vue?vue&type=template&id=6079ed20&scoped=true&"
import script from "./address.vue?vue&type=script&lang=js&"
export * from "./address.vue?vue&type=script&lang=js&"
import style0 from "./address.css?vue&type=style&index=0&id=6079ed20&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6079ed20",
  null
  
)

export default component.exports